import { Cookie } from '@common-vue/util/src/modules/cookie';
import { addToMultipleRegistry } from 'config';
import { GET_USER_REGISTRIES, ADD_TO_REGISTRY } from './types/actions';
import {
  SET_USER_REGISTRIES_RESPONSE,
  SET_USER_REGISTRY_ERROR,
  SET_ADD_TO_REGISTRY_LOADING_STATE,
  SET_USER_REGISTRY_LOADING_STATE,
  SET_ADD_TO_REGISTRY_RESPONSE,
  SET_ADD_TO_REGISTRY_ERROR_MESSAGE,
  SET_RESET_STATE,
  SET_SUCCESS_STATE,
  SET_USER_REGISTRY_STATUS_ERROR,
} from './types/mutations';
import { httpUpdateAPIHeaders } from './utils/APIUtils'; // eslint-disable-line import/extensions
import { setRegistryDetails } from './utils/LocalStorageUtils';

const $http = require('@vue-util/http');

const USER_REGISTRY_ENDPOINT = '/regsvc/registry/api/v1/registry/association';
const ADD_TO_REGISTRY_ENDPOINT = '/regsvc/registry/api/v2/preference/addPreference';

export default {
  namespaced: true,
  state: {
    userRegistries: [],
    userRegistryError: null,
    loadingState: false,
    userRegistryloadingState: false,
    atrSuccessState: false,
    atrResponse: {},
    atrError: null,
    userRegistrySuccessState: false,
    userRegistryStatusError: false,
  },
  getters: {},
  mutations: {
    [SET_USER_REGISTRIES_RESPONSE](state, userRegistry) {
      state.userRegistries = userRegistry;
    },
    [SET_USER_REGISTRY_ERROR](state, error) {
      state.userRegistryError = error;
    },
    [SET_ADD_TO_REGISTRY_LOADING_STATE](state, loadValue) {
      state.loadingState = loadValue;
    },
    [SET_USER_REGISTRY_LOADING_STATE](state, loadValue) {
      state.userRegistryloadingState = loadValue;
    },
    [SET_ADD_TO_REGISTRY_RESPONSE](state, addToRegistry) {
      state.atrResponse = addToRegistry;
    },
    [SET_ADD_TO_REGISTRY_ERROR_MESSAGE](state, error) {
      state.atrError = error;
    },
    [SET_SUCCESS_STATE](state, success) {
      state.atrSuccessState = success;
    },
    [SET_RESET_STATE](state) {
      state.userRegistries = {};
      state.userRegistryError = null;
      state.loadingState = false;
      state.userRegistryloadingState = false;
      state.atrSuccessState = false;
      state.atrResponse = {};
      state.atrError = null;
      state.userRegistryStatusError = false;
    },
    [SET_USER_REGISTRY_STATUS_ERROR](state, value) {
      state.userRegistryStatusError = value;
    },
  },
  actions: {
    async [GET_USER_REGISTRIES]({ commit, rootState }, { payload, apigeeData }) {
      commit(SET_USER_REGISTRY_LOADING_STATE, true);
      commit(SET_USER_REGISTRY_STATUS_ERROR, false);
      try {
        const { PersistentLoginUtil } = await import(/* webpackChunkName: "persistent-login", webpackPrefetch: true */ '@vue-util/persistentLogin');
        const deviceFingerPrint = PersistentLoginUtil.getDeviceFingerPrintHeaders();
        const isLogin365Customer = (Cookie.get('Login365Customer', 'MISCGCs') === 'Y') || false;
        const headers = {
          'X-Macys-Login365Customer': isLogin365Customer,
          ...deviceFingerPrint,
        };
        const response = await $http.post(
          `${USER_REGISTRY_ENDPOINT}`,
          payload,
          {
            headers: httpUpdateAPIHeaders(rootState, payload, apigeeData, headers),
          },
        );
        const isError = response?.data?.errors || response?.data?.error;
        if (!isError) {
          const data = response?.data?.registryInfo;
          setRegistryDetails(data);
          commit(SET_USER_REGISTRIES_RESPONSE, data);
        } else {
          commit(SET_USER_REGISTRY_ERROR, isError);
        }
      } catch (error) {
        if (error.response?.status === 401) {
          Cookie.set('SignedIn', '0');
          commit(SET_USER_REGISTRY_STATUS_ERROR, true);
        }
        commit(SET_USER_REGISTRY_ERROR, error);
        commit(SET_USER_REGISTRIES_RESPONSE, {});
      }
      commit(SET_USER_REGISTRY_LOADING_STATE, false);
    },

    async [ADD_TO_REGISTRY]({ commit, rootState }, { payload, apigeeData }) {
      commit(SET_ADD_TO_REGISTRY_LOADING_STATE, true);
      commit(SET_SUCCESS_STATE, false);
      commit(SET_ADD_TO_REGISTRY_ERROR_MESSAGE, null);
      try {
        const { Experimentation } = await import('@common-vue/util/src/modules/experimentation');
        const { PersistentLoginUtil } = await import(/* webpackChunkName: "persistent-login", webpackPrefetch: true */ '@vue-util/persistentLogin');
        const deviceFingerPrint = PersistentLoginUtil.getDeviceFingerPrintHeaders();
        const experimentIds = Experimentation.getExpIds().toString();
        const isLogin365Customer = (Cookie.get('Login365Customer', 'MISCGCs') === 'Y') || false;
        const headers = {
          'X-Macys-Experiment-Ids': experimentIds,
          'X-Macys-Login365Customer': isLogin365Customer,
          ...deviceFingerPrint,
        };
        const response = await $http.post(
          `${ADD_TO_REGISTRY_ENDPOINT}`,
          payload,
          {
            headers: httpUpdateAPIHeaders(rootState, payload, apigeeData, headers),
          },
        );
        const isError = response?.data?.errors || response?.data?.error;
        if (!isError) {
          const data = response?.data?.registryInfo;
          commit(SET_ADD_TO_REGISTRY_RESPONSE, data);
          const userRegistriesData = data?.userInfoRegistriesResponse;
          setRegistryDetails(userRegistriesData);
          commit(SET_SUCCESS_STATE, true);
        } else {
          commit(SET_ADD_TO_REGISTRY_ERROR_MESSAGE, isError?.[0]?.description || addToMultipleRegistry.errorMsg);
          commit(SET_SUCCESS_STATE, false);
        }
      } catch (error) {
        const errorResponse = error?.response?.data?.errors?.[0] || error?.response?.data?.error?.[0];
        commit(SET_ADD_TO_REGISTRY_ERROR_MESSAGE, errorResponse?.message || addToMultipleRegistry.errorMsg);
        commit(SET_SUCCESS_STATE, false);
        commit(SET_ADD_TO_REGISTRY_RESPONSE, {});
      }
      commit(SET_ADD_TO_REGISTRY_LOADING_STATE, false);
    },
  },
};
